import { PagingResultsViewModel } from "../../../../core/_infrastructure/types/common";


export class NumeroSeguridadItemResultsViewModel extends PagingResultsViewModel {

    public ResultList: NumeroSeguridadViewModel[];
}


export class NumeroSeguridadViewModel {

    constructor() {

    }

    Id: number = 0;
    IdSolicitudEx: number | null;
    IdPagina: number | null;
    IdZona: number | null;
    IdPif: number | null;
    NumSeguridad: number;
    IdCopiaEx: number | null;
}











